import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, Form, message } from "antd";
import { useEffect } from "react";
import { handleDeleteDealActivity } from "../../../../api/deals";

export default function DeleteActivity({
  isVisible,
  setVisible,
  activity,
  deal_id,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: handleDeleteDealActivity,
    onSuccess: () => {
      message.success("Deleted Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["deals", deal_id] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    await mutate({ deal_id, activity_id: activity?._id });
    setVisible(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [activity, form]);

  return (
    <Modal
      open={isVisible}
      title="Delete Activity"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="deleteDealActivity"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Delete
        </Button>,
      ]}
    >
      <Form
        id="deleteDealActivity"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-col items-center justify-center my-8">
          <div>
            Are you Sure you want to
            <span className="text-automark-dark font-bold mx-1">Delete</span>
            this Activity
          </div>
          <div className="font-bold text-lg">{activity?.description}?</div>
        </div>
      </Form>
    </Modal>
  );
}
